import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {OAuthService} from 'angular-oauth2-oidc-codeflow';
import {AuthenticationService} from '../../../_services/authentication.service';
import {Router} from '@angular/router';
import {ApiCapaService} from '../../../_services/apiCapa.service';
import {SujetModel} from '../../../_models/CapaModels/Sujet.model';
import {EvaluationModel} from '../../../_models/CapaModels/Evaluation.model';
import {CountryModel} from '../../../_models/CapaModels/Country.model';
import {ParametreMOModel} from '../../../_models/CapaModels/ParametreMO.model';

@Component({
  selector: 'app-result-view',
  templateUrl: './result-view.component.html',
  styleUrls: ['./result-view.component.css']
})
export class ResultViewComponent implements OnInit {

  Evaluation: EvaluationModel;
  Subject: SujetModel;
  Country: CountryModel;
  ParametreMO: ParametreMOModel;

  TestDuration: string;
  PAR: string;
  AverageAnswerAmoutPerFrequency: string;
  informationsOpen: boolean = true;

  constructor(private oauthService: OAuthService,
              private cdRef: ChangeDetectorRef,
              private authenticationService: AuthenticationService,
              private router: Router,
              private ApiClient: ApiCapaService) { }

  ngOnInit() {
    this.getEvaluation();
  }

  getPAR() {
    /// si le type de test est 2 ou 5 c’est un PAR7. Si le type de test est 3 ou 4 c’est un PAR3
    this.PAR =
        this.Evaluation.typeTest === 2 ||
        this.Evaluation.typeTest === 5 ? 'PAR7' :
            (this.Evaluation.typeTest === 3 ||
            this.Evaluation.typeTest === 4 ? 'PAR3' : '');
  }

  getAverageAnswerAmountPerFrequency() {
      this.ApiClient.get('Evaluations/answer-amount/' + this.Evaluation.idEvaluation).subscribe(result => {
          this.AverageAnswerAmoutPerFrequency = result.round;
      });
  }

  getEvaluation() {
    const IDEvaluation = this.router.url.split('/')[4];
    this.ApiClient.get('Evaluations/' + IDEvaluation).subscribe(response => {
      this.Evaluation = response;

      this.getSubject();
      this.getCountry();
      this.getParametreMO();
      this.getPAR();
      this.getAverageAnswerAmountPerFrequency();

      const DateDiff = new Date((new Date(this.Evaluation.heureFin)).valueOf() - (new Date(this.Evaluation.heureDebut)).valueOf());
      this.TestDuration = DateDiff.getMinutes() + ':' + DateDiff.getSeconds();
    });
  }

  getSubject() {
    const IDSujet = this.Evaluation.idSujet;
    this.ApiClient.get('Sujets/' + IDSujet).subscribe(response => {
      this.Subject = response;
    });
  }

  getCountry() {
    const IDCountry = this.Evaluation.idCountry;
    this.ApiClient.get('Countrys/' + IDCountry).subscribe(response => {
      this.Country = response;
    });
  }

  getParametreMO() {
    const IDParametreMO = this.Evaluation.idParametreMoD;
    this.ApiClient.get('ParametresMO/' + IDParametreMO).subscribe(response => {
      this.ParametreMO = response;
    });
  }
}
